import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../services/app.service'

interface ListConfigInterface {
  content?: string | Array<{ value: string, languageCode: string }>;
  class?: string;
  mapping?: {
    source: string;
    labelKey?: string;
    contentKey?: string;
    nestedKey?: string;
    listKey?: string;
  };
  legend?: any;
  listItemLegend?: any;
  pageLinks?: Array<any>; //Array containing page linking per level
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  @Input() config: ListConfigInterface;
  @Input() list?: Array<any>; //nested list
  @Input() data: any; //diData provided for lookup
  @Input() controls: Array<any> = []; //list item controls nested in list control
  @Input() level?: number = 0; //nesting level
  @Input() listIndex?: number; //index of list item in above level

  formattedList: Array<any> = []; //resolved list
  pageURL: any; //url object linking list items to pages

  mappingSource: string;


  constructor(private appService: AppService) { }

  /**
   * List Component - Method to map list/list-item's label
   * @author Abhishek
   * @author Neil C
   * @task QLIKTAG-2961
   */
  ngOnInit() {

    // console.log('LIST CONFIG', this.config);
    // console.log('LIST DATA', this.data);

    //resolve pageLink
    if (this.config.hasOwnProperty('pageLinks')) {
      this.pageURL = this.getPageURL(this.config.pageLinks, this.level);
    }

    //COMMENTED BY NEIL 18/06/2019
    // if(this.config.hasOwnProperty('legend')){
    //
    //   if(Array.isArray(this.config.legend)){
    //     this.config.legend = this.appService.resolveLegend(this.config.legend, this.data);
    //   }
    //
    //
    // }




    //console.log('MAP SOURCE',this.mappingSource);

    //If list is not provided resolve it from mapping
    if (!this.list && this.config.hasOwnProperty('mapping')) {

      let source = this.config.mapping.source;
      this.mappingSource = source ? this.data[source] : null;

      if (this.config.mapping.hasOwnProperty('listKey') && this.mappingSource) {
        this.list = this.appService.findObjectByPath(this.mappingSource, this.config.mapping.listKey.split('.'));
      }
    }




    // If list item controls are provided
    if (this.controls && this.controls.length > 0) {
      //this.list = this.getListItems(this.controls);
      this.list = this.controls;

    }

    if (!this.list) {
      return false;
    }

    //  console.log('BEFORE FORMAT', this.list)

    //NOTE: FOR lists nested in list-item the first control is a list not array of list-items
    let nested = [];
    nested = this.list.filter((item) => { return item.ctrlName === 'list' });
    //console.log('nestd', nested);
    if (nested.length > 0) {
      this.list = nested[0].controls;
    }

    this.list.forEach((item, i) => {
      // const contentR = this.config?.content;
      if (Array.isArray(this.config.content)) {
        const regex = /{{(.*?)}}/g;
        let match;
        const arr: string[] = [];
        while ((match = regex.exec(this.config.content[0].value)) !== null) {
          arr.push(match[1]);
        }
        const updatedArr = arr.map(value => value.replace(/\d+/, i.toString()));

        let updatedContent = this.config.content[0].value;
        arr.forEach((originalValue, index) => {
          const placeholder = `{{${originalValue}}}`;
          const newValue = `{{${updatedArr[index]}}}`;
          updatedContent = updatedContent.replace(new RegExp(placeholder, 'g'), newValue);
        });
        console.log(updatedArr);
        if (i != 0 ) {
          let val = {
            languageCode: this.config?.content[0].languageCode,
            value: updatedContent
          }

          this.config.content.push(val);
        }
      }
    });


    this.formattedList = this.list.reduce((acc, item, index) => {
      //list only mode
      let content = Array.isArray(this.config.content) ? this.config.content.filter((_, i) => i === index) 
      : this.config.content ? this.config.content : ''
      let label = '';
      let icon = '';
      let url = this.pageURL;
      let controls = [];
      let classList = '';

      if (item.hasOwnProperty('config')) {

        if (item.config.hasOwnProperty('label')) {

          label = item.config.label;
        }

        if (item.config.hasOwnProperty('content')) {

          content = item.config.content;
        }

        if (item.config.hasOwnProperty('icon')) {
          icon = item.config.icon;
        }

        if (item.config.hasOwnProperty('url')) {
          url = item.config.url;
        }

        if (item.config.hasOwnProperty('class')) {
          classList = item.config.class;
        }

        if (item.hasOwnProperty('controls')) {
          controls = item.controls;
        }

      }

      let listItem = {
        "config": {
          //  "legend": this.config.listItemLegend ? this.config.listItemLegend : null,
          "label": label,
          "content": content,
          "url": url ? url : null,
          "icon": icon,
          "mapping": {},
          "class": classList ? classList : ''

        },
        "controls": controls,
        "listData": { ...item }

      };

      if (this.config.hasOwnProperty('mapping')) {

        listItem.config.mapping = this.config.mapping;


        //If list contains nested lists
        if (this.config.mapping.hasOwnProperty('nestedKey')) {

          if (this.config.mapping.nestedKey) {

            let nested = this.appService.findObjectByPath(item, this.config.mapping.nestedKey.split('.'));

            if (nested && Array.isArray(nested)) {
              listItem['controls'] = nested;
            }
          }
        }




      }

      acc.push(listItem);
      return acc;
    }, []);

    console.log('Formatted List',this.formattedList);
    
    

    // for(let i=0;i<this.formattedList.length;i++){
    //   this.formattedList[i].config.content[0].value = updatedArrayContent[i];
    //   console.log(this.formattedList);
    // }

    // this.formattedList.forEach((contents,i)=>{
    //   console.log(contents)
    //   contents.config.content[0].value = updatedArrayContent[i];
    //   console.log(this.formattedList);
    // })

    // console.log(this.formattedList);

  }



  /**
   * [return pageURL object for the provided level]
   * @param  pageLinks [Array containing pageURL objects for each level]
   * @param  level     [Level number to retrive]
   * @author Neil
   * @return           [PageURL object]
   */
  getPageURL(pageLinks, level: number) {
    let result;

    if (pageLinks.length > 0) {
      result = pageLinks[level];
    }

    return result;
  }

}
